import { render, staticRenderFns } from "./DespesasPagamento.vue?vue&type=template&id=fae5a792"
import script from "./DespesasPagamento.vue?vue&type=script&lang=js"
export * from "./DespesasPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports